import {
  FETCH_RATES_GRAPH_REQUEST,
  FETCH_RATES_GRAPH_SUCCESS,
  FETCH_RATES_GRAPH_FAILURE,
} from 'actionTypes';

import createReducer from './createReducer';

export const initialState = {};

export const ratesGraph = createReducer(initialState, {
  [FETCH_RATES_GRAPH_REQUEST]: (
    state,
    { payload: { currenciesKey, periodKey, type } }
  ) => {
    return {
      ...state,
      [type]: {
        ...(state[type] || {}),
        [currenciesKey]: {
          ...(state[type]?.[currenciesKey] || {}),
          [periodKey]: {
            ...(state[type]?.[currenciesKey]?.[periodKey] || {}),
            isFetching: true,
            isInitialized: false,
          },
        },
      },
    };
  },

  [FETCH_RATES_GRAPH_SUCCESS]: (
    state,
    { payload: { currenciesKey, periodKey, entities, ids, type } }
  ) => {
    return {
      ...state,
      [type]: {
        ...state[type],
        [currenciesKey]: {
          ...state[type]?.[currenciesKey],
          [periodKey]: {
            ...state[type]?.[currenciesKey]?.[periodKey],
            entities,
            ids,
            isFetching: false,
            isInitialized: true,
          },
        },
      },
    };
  },

  [FETCH_RATES_GRAPH_FAILURE]: (
    state,
    { payload: { currenciesKey, periodKey, type } }
  ) => ({
    ...state,
    [type]: {
      ...state[type],
      [currenciesKey]: {
        ...state[type]?.[currenciesKey],
        [periodKey]: {
          ...state[type]?.[currenciesKey]?.[periodKey],
          isFetching: false,
          isInitialized: true,
        },
      },
    },
  }),
});

export default ratesGraph;
